module.exports = __webpack_public_path__ + "assets/img/avatar.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/avatar.jpg
// module id = 1952
// module chunks = 0